import { css } from 'styled-components'
import { breakpoints, breakpointSizes } from 'theme/breakpoints'

const colorBuilder = ({ red, green, blue, alpha }) => `rgba(${red},${green}, ${blue}, ${alpha})`

/**
 *
 * @export themeMapper
 * @description Takes theme colors returned by GQL query(RBGA values) and turns them into hex values.
 * @param {*} { primary, secondary, primaryCta, soft }
 * @returns newTheme, the theme using hex values rather than rbgba.
 *
 */
export const themeMapper = ({ primary, secondary, primaryCta, soft, reasonsToHireMeCta }) => {
  const newTheme = {
    colors: {
      inverseColor: colorBuilder(primary),
      secondary: colorBuilder(secondary),
      primaryCta: colorBuilder(primaryCta),
      soft: colorBuilder(soft),
      reasonsToHireMeCta: colorBuilder(reasonsToHireMeCta),
    },
  }
  return newTheme
}

export const respondTo = Object.keys(breakpointSizes).reduce<any>((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${breakpoints[label]}) {
      ${// @ts-ignore
      css(...args)};
    }
  `
  return acc
}, {})
